import React from 'react';
import {Toolbar} from 'react-admin';
import {COLUMN, ARTICLE_SECTION} from '../../consts/Names';
import {SaveWithUpdateButton, SaveWithCreateButton} from '../utils/RecordWrappers';

export const ColumnEditToolbar = (props) => {
   const {className} = props
   return (
   <Toolbar {...props} className={className}>
      <SaveWithUpdateButton replaceFunction={reworkedData} updatedSource={COLUMN.SOURCE} redirect={`/${COLUMN.SOURCE}`}  submitOnEnter={false} variant="text" />
   </Toolbar>
)};
const reworkedData = (props) => {
   if(props.content){
      props.text = props.content;
      delete props.content;
   }
   if (props.isHightlight){       
      props.section = ARTICLE_SECTION.HIGHTLIGHT;
   }
   else 
      props.section = ARTICLE_SECTION.CAROUSEL;
   delete props.isHightlight;
   if(props.text.indexOf('<div class="ql-editor">') === -1){
      props.text = '<div class="ql-editor">' + props.text + '</div>' 
   }
   // if(props.keyword_ids.length)
   //    props.keyword_ids = props.keyword_ids.map(el=>el.id);

   return props;
   // const {category_ids, title, state, content, images, section} = props;
   // const obj = {category_ids, title, state, text: content, images, section};
   // return obj;
};

// const reworkedData = (props) => {
//    if (props.isHightlight){       
//        props.section = ARTICLE_SECTION.HIGHTLIGHT;
//    }
//    else 
//       props.section = ARTICLE_SECTION.CAROUSEL;
//    delete props.isHightlight;
//    return Object.assign({}, props);
// };

export const ColumnCreateToolbar = (props) => {
   const {className} = props;
   return(
   <Toolbar {...props} className={className}>
      <SaveWithCreateButton replaceFunction={reworkedData} updatedSource={COLUMN.SOURCE} redirect={`/${COLUMN.SOURCE}/`} 
      submitOnEnter={false} variant="text"  undoable={false} />      
   </Toolbar>
)}